import angular from 'angular';

// od-scroll-stay is an attribute that goes on a scroll container which
// contains an `ngRepeat`. Its value should be set to the same collection which
// the `ngRepeat` expression watches. When the collection changes, this
// directive adjusts the `scrollTop` of the container so that the addition or
// removal of the `ngRepeat`ed elements appears to not scroll.
//
// <ul
//   od-scroll-stay="items"
//   style="overflow: scroll; height: 100px;"
//   ng-init="items = [0, 1, 2, 3]">
//   <li ng-repeat="item in items" style="height: 50px;">{{item}}</li>
// </ul>
// <button ng-click="items.unshift(items.length)">Prepend an item</button>
// The list doesn't move as elements are added to the top.
module.exports = angular.module('common.directives.od-scroll-stay', [])
.directive('odScrollStay', function() {
  return {
    restrict: 'A',
    controller: class {
      constructor($element, $attrs) {
        this.$element = $element;
        this.collection = $attrs.odScrollStay;
      }

      offset(height) {
        this.$element.prop('scrollTop', this.$element.prop('scrollTop') + height);
      }
    }
  };
})
.directive('ngRepeat', function() {
  return {
    restrict: 'A',
    require: '?^^odScrollStay',
    link(scope, elem, attrs, odScrollStay) {
      if (!odScrollStay) return;

      // based on https://github.com/angular/angular.js/blob/v1.4.8/src/ng/directive/ngRepeat.js#L349 // eslint-disable-line max-len
      const collection = attrs.ngRepeat.match(/in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/)[1]; // eslint-disable-line max-len
      if (collection === odScrollStay.collection) {
        scope.$evalAsync(function() {
          odScrollStay.offset(+elem.prop('offsetHeight'));
        });
        scope.$on('$destroy', function() {
          odScrollStay.offset(-elem.prop('offsetHeight'));
        });
      }
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/od-scroll-stay.js
 **/